import { FileDown } from 'lucide-react';
import { ExportReportsPanel } from '@/components/reports/ExportReportsPanel';

export const ReportsPage = ({ readOnly = false }: { readOnly?: boolean }) => (
  <div className="space-y-6">
    <div>
      <h2 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
        <FileDown className="h-6 w-6 text-primary-600" />
        Raporty CSV
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Pobierz wyniki i zestawienia w formacie CSV
      </p>
    </div>

    <ExportReportsPanel readOnly={readOnly} />
  </div>
);
